import React from "react";
import { Helmet } from "react-helmet-async";
import { match as Match } from "react-router-dom";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../utils";
import ProviderForm from "../form";
import PageSubheader from "../../../components/PageSubheader";

interface Props {
  administrator: boolean;
  match: Match<{ id: string }>;
  intl: IntlShape;
  backURL: string;
}

const ProviderCreate = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({ id: "page.provider.create.document.title" })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-provider-create"
        goBackURL={backURL}
      />

      <ProviderForm {...props} edition={false} />
    </>
  );
};

export default withOneColLayout(injectIntl(ProviderCreate));
